import { api } from './api';

export interface CodigoBarrasInformacoes {
  id: number;
  referenciaInformada: string;
  valorInformado: string;
  tamanho: string;
  quantidade: number;
  descricao: string;
  dataGeracao?: string;
}

export interface CodigoBarrasRequest {
  id?: number;
  referenciaInformada: string;
  valorInformado: string;
  tamanho: string;
  quantidade: number;
  descricao: string;
}

export interface CodigoBarraCommand {
  codigoBarra: string[];
  idProduto?: number;
}

export const codigoBarrasService = {
  // Buscar todos os códigos de barras
  getAll: async (): Promise<CodigoBarrasInformacoes[]> => {
    const response = await api.get<CodigoBarrasInformacoes[]>('/api/CodigoBarras/GetAll');
    return response.data;
  },

  // Salvar código de barras
  save: async (codigoBarras: CodigoBarrasRequest): Promise<CodigoBarrasInformacoes> => {
    const response = await api.post<CodigoBarrasInformacoes>('/api/CodigoBarras/Salvar', codigoBarras);
    return response.data;
  },

  // Gerar PDF para impressão
  imprimir: async (id: number): Promise<Blob> => {
    const response = await api.get<Blob>(`/api/CodigoBarras/CodigoBarrasPDF?idCodBarrasInformacoes=${id}`);
    return response.data;
  },

  // Validar códigos de barras disponíveis
  validarDisponiveis: async (codigos: string[], idProduto?: number): Promise<string> => {
    const response = await api.post<string>('/api/CodigoBarras/ValidarCodigoDeBarrasDisponiveis', {
      CodigoBarra: codigos,
      IdProduto: idProduto,
    });
    return response.data;
  },

  // Validar códigos em outra entrada
  validarEmOutraEntrada: async (codigos: string[]): Promise<string> => {
    const response = await api.post<string>('/api/CodigoBarras/ValidarCodigoEmOutraEntrada', {
      CodigoBarra: codigos,
    });
    return response.data;
  },

  // Gerar PDF A4
  imprimirA4: async (id: number): Promise<Blob> => {
    const response = await api.get<Blob>(`/api/CodigoBarras/CodigoBarrasPDFA4?idCodBarrasInformacoes=${id}`);
    return response.data;
  },
};
